import {connect} from "redux-vue";
import * as userActions from "../actions/user";
import PageTemplate from "./PageTemplate";
import {getCountryCode} from "../helpers/isoCountries";

const ProfilePage = {
  props: ['user', 'app', 'uploadPhoto'],

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const role = this.app.roles.find(i => i.id == this.user.model.role);
    const country = this.app.countries.find(i => i.id == this.user.model.country_id);
    const isoCountry2Code = country ? getCountryCode(country.country) : null;

    return (
      <PageTemplate>
        <div class="relative lg:pb-32 bg-primary">
          <div class="bg-gray-300 absolute left-0 top-0 bottom-0 w-1/2 z-0 hidden lg:block"></div>

          <div class="container mx-auto">
            <div class="flex flex-col lg:flex-row items-end lg:py-16">
              <div class="w-full lg:w-1/2">
                <div class="bg-gray-300">

                  <div class="flex items-end justify-center z-10 relative h-full">
                    <div class="flex flex-col lg:flex-row items-center justify-center py-5 lg:py-0">

                      <div
                        class="bg-action hover:bg-action-dark h-20 lg:h-56 w-20 lg:w-56 rounded-full shadow-2xl flex-shrink-0 p-1 lg:p-3 mb-1 lg:mb-0">
                        <div class="h-full w-full p-px lg:p-0 relative">
                          <div class="absolute top-0 left-0 right-0 bottom-0 rounded-full bg-white z-0">
                            <div class="flex items-center justify-center h-full">
                              <i class="mdi mdi-account scale-150 text-2xl lg:text-6xl text-gray-800 transform"></i>
                            </div>
                          </div>
                          <img src={process.env.VUE_APP_BASE + "/storage/" + this.user.model.avatar} alt="" class="h-full w-full rounded-full shadow-md relative z-20"/>
                        </div>
                      </div>

                      <div class="lg:ml-6 flex flex-col items-center lg:items-start">
                        <p class="text-xl lg:text-4xl text-gray-800 mb-3">
                          {this.user.model.name}
                        </p>
                        <router-link to={{name: 'ProfileEditPage'}} class="bg-action hover:bg-action-dark rounded-full p-3 py-1 text-white text-xs lg:text-base">
                          <i class="mdi mdi-pencil mr-1"></i>
                          {this.$t('profile_page.edit_profile')}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w-full lg:w-1/2">
                <div class="transform lg:-translate-x-12">
                  <div class="flex items-center justify-center">
                    <div class="px-6 lg:px-0">
                      <p class="hidden lg:block text-2xl mb-8 text-white">
                        {this.$t('profile_page.profile_information')}
                      </p>
                      <ul class="text-sm lg:text-base text-white my-5 lg:my-0 break-all max-w-sm">
                        <li class="mb-5">
                          <div class="flex items-center">
                            <div class="h-10 lg:h-12 w-10 lg:w-12 p-px rounded-full bg-gray-300 mr-3">
                              <div class="h-full w-full rounded-full p-px">
                                <div class="bg-primary h-full w-full rounded-full">
                                  <div class="flex items-center justify-center h-full">
                                    <i class="mdi mdi-account-badge text-white text-xl"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p>
                              {role && role.role}
                            </p>
                          </div>
                        </li>
                        <li class="mb-5">
                          <div class="flex items-center">
                            <div class="h-10 lg:h-12 w-10 lg:w-12 p-px rounded-full bg-gray-300 mr-3">
                              <div class="h-full w-full rounded-full p-px">
                                <div class="bg-primary h-full w-full rounded-full">
                                  <div class="flex items-center justify-center h-full">
                                    <i class="mdi mdi-map-marker text-white text-xl"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p>
                              <i class={`flag-icon flag-icon-${isoCountry2Code && isoCountry2Code.toLowerCase()} mr-1`}></i>
                              {country && country.country}
                            </p>
                          </div>
                        </li>
                        <li class="mb-5">
                          <div class="flex items-center">
                            <div class="h-10 lg:h-12 w-10 lg:w-12 p-px rounded-full bg-gray-300 mr-3 flex-shrink-0">
                              <div class="h-full w-full rounded-full p-px">
                                <div class="bg-primary h-full w-full rounded-full">
                                  <div class="flex items-center justify-center h-full">
                                    <i class="mdi mdi-email text-white text-xl"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p class="max-w-sm">
                              <i class="mdi mdi-lock"></i>
                              {this.user.model.email}
                            </p>
                          </div>
                        </li>
                        <li>
                          <div class="flex items-center">
                            <div class="h-10 lg:h-12 w-10 lg:w-12 p-px rounded-full bg-gray-300 mr-3">
                              <div class="h-full w-full rounded-full p-px">
                                <div class="bg-primary h-full w-full rounded-full">
                                  <div class="flex items-center justify-center h-full">
                                    <i class="mdi mdi-phone text-white text-xl"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p>
                              <i class="mdi mdi-lock"></i>
                              {this.user.model.mobile || "--"}
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageTemplate>
    )
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    app: state.app,
  };
}

function mapActionToProps(dispatch) {
  return {
    uploadPhoto: (data) => dispatch(userActions.uploadPhoto(data)),
  };
}

export default connect(mapStateToProps, mapActionToProps)(ProfilePage);